import type { Translated } from '@uefadigital/panenka';
import {
  PkRadio,
  PkRadioOption,
  PkAccordionItem,
  PkAccordionItemTitle,
  PkAccordionItemContent,
  PkBadge,
  PkSpinner,
} from '@uefadigital/panenka-react';
import { memo, useCallback, useState } from 'react';

import { useTeams } from '../../../hooks/teams';

import { useTranslateFn } from '@shared/Translate';
import type { Team } from '@shared-types/match.types';

import * as styles from '../styles.module.scss';

const TeamOption = ({
  team,
  checked,
  handleFilter,
}: {
  team: Translated<Team>;
  checked: boolean;
  handleFilter: (
    event: CustomEvent<{
      selectedValue: string;
      checked: boolean;
    }>,
  ) => void;
}) => {
  const primaryText = team?.displayName;
  return (
    <PkRadioOption value={team.id} uid={team.id} onPkChange={handleFilter} checked={checked}>
      <PkBadge
        alt={primaryText}
        badgeTitle={primaryText}
        fallbackImage='club-generic-badge'
        src={team?.logoUrl}
        size={24}
      />
      <span className={styles.filterLabel} title={primaryText}>
        {primaryText}
      </span>
    </PkRadioOption>
  );
};

const FilterTeam = ({ onFilterChange, filter }: { onFilterChange: any; filter: string }) => {
  const t = useTranslateFn();
  const { teams } = useTeams();
  const [selectedTeam, setSelectedTeam] = useState(filter);

  const handleFilter = useCallback(
    (event: CustomEvent<{ selectedValue: string; checked: boolean }>) => {
      if (!event.detail.checked) return;
      setSelectedTeam(event.detail.selectedValue ? event.detail.selectedValue : null);
      onFilterChange(event.detail.selectedValue);
    },
    [onFilterChange],
  );

  return (
    <>
      {teams && (
        <PkAccordionItem expanded>
          <PkAccordionItemTitle>{t(window?.isClub ? 'club' : 'team')}</PkAccordionItemTitle>
          <PkAccordionItemContent>
            <div>
              <PkRadio name='teamid'>
                <PkRadioOption value='' onPkChange={handleFilter} checked={!selectedTeam}>
                  {t(window?.isClub ? 'history_all_clubs' : 'all_teams')}
                </PkRadioOption>
                {teams.map((t) => (
                  <TeamOption key={t.id} team={t} handleFilter={handleFilter} checked={`${selectedTeam}` === t.id} />
                ))}
              </PkRadio>
            </div>
          </PkAccordionItemContent>
        </PkAccordionItem>
      )}
      {!teams && <PkSpinner />}
    </>
  );
};

export default memo(FilterTeam);
